import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TelegramContext } from 'context/Context';
import { getItemFromStore, setItemToStore } from 'helpers/utils';

const amenities = [
 'Áreas verdes y espacios para recreación al aire libre',
 'Piscina y/o jacuzzi',
 'Gimnasio o centro de fitness',
 'Área de juegos para niños',
 'Servicio de conserjería',
 'Estacionamiento privado y seguro',
 'Servicio de seguridad las 24 horas',
 'Sala de cine',
 'Sala de eventos y/o reuniones',
 'Terraza o espacio de esparcimiento al aire libre con vistas panorámicas',
 'Servicio de limpieza y mantenimiento de la propiedad',
 'Acceso a internet de alta velocidad',
 'Sistema de automatización para controlar la iluminación y temperatura de las habitaciones'
];

const defaultValues = JSON.parse(localStorage.getItem('createProyect')) || {
 name: '',
 logo: null,
 projectStart: null
};

const defaultAmenities = JSON.parse(localStorage.getItem('amenities')) || {
 amenities: [],
 options: amenities.map(a => ({ value: a, label: a }))
};

const TelegramProvider = ({ children }) => {
 const [project] = useState(defaultValues);
 const [select, setSelect] = useState(defaultAmenities);

 useEffect(() => {
  const arrayData = getItemFromStore('amenities');
  setItemToStore('amenities', { ...arrayData, ...select });
 }, [select]);

 const value = { select, setSelect, project };
 return <TelegramContext.Provider value={value}>{children}</TelegramContext.Provider>;
};

TelegramProvider.propTypes = {
 children: PropTypes.node.isRequired
};

export default TelegramProvider;
